import SVTAPI from './svtapi';

class Expense extends SVTAPI {
  /**
   * Initializes a new, existing expense.
   *
   * @param {number} pid The pid of the expense
   */
  constructor(pid) {
    super('/expense');
    this._pid = pid;
  }

  /**
   * GET /expense/:pid
   * Gets data of a single expense.
   *
   * @returns {Object} The server's response
   */
  get() {
    return super.get({ url: '/' + this._pid });
  }

  /**
   * PATCH /expense/:pid
   * Updates expense data.
   *
   * @param   {Object} data The data to update
   * @returns {Object}      The server's response
   */
  patch(data) {
    return super.patch({ url: '/' + this._pid, data });
  }

  /**
   * DELETE /expense/:pid
   * Deletes an expense.
   *
   * @returns {Object}      The server's response
   */
  remove() {
    return super.remove({ url: '/' + this._pid });
  }
}

export default Expense;
